<template>

<core-modal v-on:close="onClose" :nopadding="true" icon="caret-left">

	<template v-slot:head>

		Add Rule

	</template>

	<template v-slot:default>

        <com-filter v-model="model.rule" />

		<com-filter v-model="model.links[key]" v-for="(link, key) in model.links" :key="key" />

    	<com-summary :type="type" :value="model" :is-valid="isValid" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" :disabled="!isValid" v-on:click.native="onConfirmClick" v-if="is.new">Add rule</core-button>
		<core-button theme="blue" :disabled="!isValid" v-on:click.native="onConfirmClick" v-if="!is.new">Apply changes</core-button>

    </template>

</core-modal>

</template>

<script>

import $filter from '@/filter'
import comFilter from './rule/Filter'
import comSummary from './rule/Summary'

export default {

    props: ['data'],

	components: {
		'com-filter': comFilter,
		'com-summary': comSummary
	},

	data: function() {

		return {
			is: {
				new: true
			},
			model: {
				id: '',
				logic: 'and',
				rule: {
					type: ''
				},
				links: {}
			}
		}

	},

	created: function() {

		if(this.data.model) {

			this.model = this.$util.copy(this.data.model)
			this.is.new = false

		} else {

			this.model.rule.type = this.data.type

		}

	},

	watch: {

		links: function(n) {

			var links = {}

			this.$_.each(n, function(key) {

				links[key] = (this.model.links[key]) ? this.$util.copy(this.model.links[key]) : { type: key }

			}.bind(this))

			this.model.links = links

		}

	},

    computed: {

		isValid: function() {

			var checkValid = function(rule) {

				if (rule.logic) {

					var valid = true

					if ($filter.type[rule.type].type === 'set') {

						valid = rule.logic.value.length > 0

					} else {

						valid = rule.logic.value !== ''

					}

					if(valid && rule.logic.tolerance !== undefined) {

						valid = rule.logic.tolerance !== '' && parseFloat(rule.logic.tolerance) !== 0

					}

					if(valid && rule.logic.to !== undefined) {

						valid = rule.logic.to !== '' && parseFloat(rule.logic.to) !== 0

					}

					return valid

				} else {

					return false

				}

			}

			var required = 1 + this.links.length
			var passed = 0

			if(checkValid(this.model.rule)) passed++

			this.$_.each(this.model.links, function(link) {

				if(checkValid(link)) passed++

			})

			return required === passed

		},

		links: function() {

			if (!this.type) return []

			var links = []

			this.$_.each(this.type.link, function(value, key) {

				if (this.$_.isFunction(value)) {

					if (value(this.model.rule)) {

						links.push(key)

					}

				} else {

					links.push(key)

				}

			}.bind(this))

			return links

		},

        type: function() {

            return $filter.type[this.model.rule.type]

        }

    },

	methods: {

		onConfirmClick: function() {

			this.$emit('close')

			this.$store.commit('data/stash', {
				name: 'filter/directory',
				value: {
					search: '',
					type: '',
					scroll: 0
				}
			})

			this.$pubsub.$emit('filter.rule.confirm', {
				group: this.data.group,
				model: this.$util.copy(this.model)
			})

		},

		onClose: function() {

			this.$emit('close')

			if(!this.data.model) {

				this.$pubsub.$emit('open.modal', 'filterDirectory')

			}

		}

	}

}

</script>

<style scoped>

</style>